module.exports = __webpack_public_path__ + "assets/f181d2014df90a949014b84cf53d42cb.png";